<template>
  <div class="app-container" style="position: relative; z-index: 9999; pointer-events: auto; background: white; min-height: 100vh;">
    <div style="margin-bottom: 20px; padding: 10px; background: #f5f5f5; border-radius: 4px;">
      <h3>题目编辑页面状态</h3>
      <p>编辑模式: {{ quId ? '是' : '否' }}</p>
      <p>题目ID: {{ quId || '无' }}</p>
      <p>题目类型禁用: {{ quTypeDisabled ? '是' : '否' }}</p>
      <p>表单数据: {{ postForm ? '已加载' : '未加载' }}</p>
      <p>页面可操作状态: {{ pageOperable ? '可操作' : '不可操作' }}</p>
      <p>表单引用: {{ $refs.postForm ? '已创建' : '未创建' }}</p>
      <p>页面加载状态: {{ pageLoading ? '加载中' : '已加载' }}</p>
      <p>当前时间: {{ currentTime }}</p>
      <el-button type="primary" @click="testClick">测试点击</el-button>
      <el-button type="success" @click="testInput">测试输入</el-button>
    </div>
    <el-form ref="postForm" :model="postForm" :rules="rules" label-position="left" label-width="150px">
      <el-card>
        <el-form-item label="题目类型 " prop="quType">
          <el-select v-model="postForm.quType" class="filter-item"
            @change="handleTypeChange">
            <el-option v-for="item in quTypes" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="归属题库" prop="repoId">
          <repo-select v-model="postForm.repoId" :multi="false" />
        </el-form-item>

        <el-form-item label="题目内容" prop="content">
          <el-input v-model="postForm.content" type="textarea" />
        </el-form-item>

        <el-form-item label="试题图片" style="margin-left: 7px">
          <file-upload v-model="postForm.image" accept=".jpg,.jepg,.png" />
          <div v-if="postForm.image" style="margin-top: 10px;">
            <img :src="getFullImageUrl(postForm.image)" alt="预览" style="max-width: 200px; max-height: 200px; border: 1px solid #eee;" />
          </div>
        </el-form-item>

        <el-form-item label="整题解析" prop="oriPrice" style="margin-left: 7px">
          <el-input v-model="postForm.analysis" :precision="1" :max="999999" type="textarea" />
        </el-form-item>

        <el-form-item label="知识点" style="margin-left: 7px">
          <el-select
            v-model="postForm.knowledge"
            placeholder="请选择知识点"
            clearable
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in knowledgeOptions"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="分数" style="margin-left: 7px">
          <el-input-number v-model="postForm.point" :min="0" :max="100" placeholder="请输入分数" />
        </el-form-item>

        <el-form-item label="类型" style="margin-left: 7px">
          <el-input v-model="postForm.type" placeholder="请输入类型" />
        </el-form-item>

        <el-form-item label="难度等级" style="margin-left: 7px">
          <el-select v-model="postForm.level" placeholder="请选择难度等级">
            <el-option v-for="item in levels" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="链接" style="margin-left: 7px">
          <el-input v-model="postForm.url" placeholder="请输入链接地址" />
        </el-form-item>

        <el-form-item label="难度系数" style="margin-left: 7px">
          <el-input-number v-model="postForm.difficulty" :min="0" :max="1" :step="0.1" :precision="2" placeholder="请输入难度系数(0-1)" />
        </el-form-item>

        <!-- <el-form-item label="点评" prop="evaluate" style="margin-left: 7px">
          <el-input v-model="postForm.evaluate" :precision="1" :max="999999" type="textarea" />
        </el-form-item> -->
      </el-card>

      <div v-if="postForm.quType !== 4" class="filter-container" style="margin-top: 25px">
        <el-button class="filter-item" type="primary" icon="el-icon-plus" size="small" plain @click="handleAdd">
          添加
        </el-button>

        <el-table :data="postForm.options" :border="true" style="width: 90%">
          <el-table-column label="是否答案" width="120" align="center">
            <template v-slot="scope">
              <el-checkbox v-model="scope.row.isRight">答案</el-checkbox>
            </template>
          </el-table-column>

          <el-table-column v-if="itemImage" label="选项图片" width="120px" align="center">
            <template v-slot="scope">
              <el-upload
                :action="uploadAction"
                :on-success="(res, file) => handleOptionUploadSuccess(res, scope.$index)"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
                :file-list="scope.row.fileList || []"
                name="file"
                :show-file-list="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <div v-if="scope.row.image" style="margin-top: 5px;">
                <img :src="getFullImageUrl(scope.row.image)" alt="预览" style="max-width: 80px; max-height: 80px; border: 1px solid #eee;" />
              </div>
            </template>
          </el-table-column>

          <el-table-column label="答案内容">
            <template v-slot="scope">
              <el-input v-model="scope.row.content" type="textarea" />
            </template>
          </el-table-column>

          <!-- <el-table-column
            label="答案解析"
          >
            <template v-slot="scope">
              <el-input v-model="scope.row.analysis" type="textarea" />
            </template>
          </el-table-column> -->

          <el-table-column label="操作" align="center" width="100px">
            <template v-slot="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="removeItem(scope.$index)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-table v-if="postForm.quType == 4" :data="postForm.options" :border="true"
        style="width: 90%; margin-top: 30px">
        <el-table-column label="答案内容">
          <template v-slot="scope">
            <el-input v-model="scope.row.content" type="textarea" />
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitForm">保存</el-button>
        <el-button type="info" @click="onCancel">返回</el-button>
        <el-button type="warning" @click="testClick">测试按钮</el-button>
        <el-button type="info" @click="testInput">测试输入</el-button>
      </div>
      <!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-change="handleChange"
        :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload> -->
    </el-form>
  </div>
</template>

<script>
import { fetchDetail, quAdd, quDetail, quUpdate } from '@/api/question'
import { getKnowledgeBySuboptions } from '@/api/knowledge'
import RepoSelect from '@/components/RepoSelect'
import FileUpload from '@/components/FileUpload'
import { getTokenInfo } from '@/utils/jwtUtils'

export default {

  name: 'QuDetail',
  components: { FileUpload, RepoSelect },

  data() {
    return {
      quId: '',
      quTypeDisabled: false,
      pageOperable: true,
      pageLoading: false,
      currentTime: '',
      itemImage: true,
      fileList: [{
        name: '',
        url: ''
      }, {
        name: '',
        url: ''
      }],
      levels: [
        { value: 1, label: '简单' },
        { value: 2, label: '中等' },
        { value: 3, label: '困难' }
      ],

      quTypes: [
        {
          value: 1,
          label: '单选题'
        },
        {
          value: 2,
          label: '多选题'
        },
        {
          value: 3,
          label: '判断题'
        },
        {
          value: 4,
          label: '简答题'
        }
      ],

      postForm: {
        repoId: '',
        evaluate: '',
        knowledge: '',
        point: null,
        type: '',
        level: 1,
        url: '',
        difficulty: 0.5,
        // tagList: [],
        options: []
      },
      // 知识点选项数据
      knowledgeOptions: [],
      rules: {
        content: [{ required: true, message: '题目内容不能为空！' }],
        quType: [{ required: true, message: '题目类型不能为空！' }],
        level: [{ required: true, message: '必须选择难度等级！' }],
        repoId: [{ required: true, message: '请先选择题库！' }]
        // evaluate: [{ required: false, message: '请输入点评内容！' }]
      },
      uploadAction: '/api/files/upload'
    }
  },
  watch: {
    // 监听归属题库变化，调用知识点获取方法
    'postForm.repoId': {
      handler(newVal) {
        if (newVal) {
          this.getKnowledgeBySuboptions(newVal)
        }
      },
      immediate: true
    }
  },
  async created() {
    console.log('题目编辑页面初始化...')
    console.log('路由参数:', this.$route.params)
    console.log('localStorage中的quId:', localStorage.getItem('quId'))

    // 添加试题初始化
    const id = this.$route.params.id
    if (typeof id !== 'undefined') {
      console.log('通过路由参数ID编辑题目:', id)
      this.quTypeDisabled = false
      this.pageLoading = true
      try {
        await this.fetchData(id)
      } catch (error) {
        console.error('获取题目数据失败:', error)
        this.pageLoading = false
      }
    }

    // 编辑试题初始化
    this.quId = localStorage.getItem('quId')
    if (this.quId) {
      console.log('通过localStorage中的quId编辑题目:', this.quId)
      this.pageLoading = true
      try {
        await this.getQuDetail()
      } catch (error) {
        console.error('获取题目详情失败:', error)
        this.pageLoading = false
      }
    }

    // 如果既没有路由参数也没有localStorage中的ID，说明是新增模式
    if (!id && !this.quId) {
      console.log('新增题目模式')
      this.quTypeDisabled = false
      this.pageLoading = false
    }

    // 初始化当前时间
    this.currentTime = new Date().toLocaleString()
  },
  beforeDestroy() {
    localStorage.removeItem('quId')
    this.postForm = {}
  },
  methods: {
    // 测试点击功能
    testClick() {
      console.log('测试点击功能正常')
      console.log('当前页面状态:', {
        pageOperable: this.pageOperable,
        quTypeDisabled: this.quTypeDisabled,
        pageLoading: this.pageLoading,
        postForm: this.postForm
      })
      this.$message.success('点击功能正常！')
    },

    // 测试输入功能
    testInput() {
      this.currentTime = new Date().toLocaleString()
      console.log('测试输入功能正常，当前时间:', this.currentTime)
      this.$message.success('输入功能正常！时间已更新')
    },

    // 根据学科选项获取知识点
    async getKnowledgeBySuboptions(suboptions) {
      try {
        const res = await getKnowledgeBySuboptions(suboptions)
        if (res.code) {
          console.log('获取到的知识点数据:', res.data)
          // 将获取到的知识点数据存储到选项中
          this.knowledgeOptions = res.data.map(item => ({
            value: item.content,
            label: item.content,
            id: item.id
          }))
        }
      } catch (error) {
        console.error('获取知识点失败:', error)
        this.knowledgeOptions = []
      }
    },
    // 获取单题详情
    async getQuDetail() {
      try {
        const res = await quDetail(this.quId)
        console.log('获取题目详情响应:', res)

        if (res.code) {
          const data = res.data
          console.log('题目详情数据:', data)

          // 安全处理options数组
          if (data.options && Array.isArray(data.options)) {
            data.options.forEach(item => {
              if (item.isRight) {
                item.isRight = true
              } else {
                item.isRight = false
              }
            })
          } else {
            // 如果没有options，初始化为空数组
            data.options = []
          }

          // 确保repoId是字符串类型
          if (data.repoId !== null && data.repoId !== undefined) {
            data.repoId = String(data.repoId)
          }

          this.postForm = data
          this.pageOperable = true
          this.pageLoading = false
          console.log('编辑表单数据已设置:', this.postForm)
          console.log('页面已设置为可操作状态')
        } else {
          console.error('获取题目详情失败:', res.msg)
          this.$message.error('获取题目详情失败：' + (res.msg || '未知错误'))
          this.pageLoading = false
        }
      } catch (error) {
        console.error('获取题目详情异常:', error)
        this.$message.error('获取题目详情失败，请稍后重试')
        this.pageLoading = false
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },

    handleTypeChange(v) {
      this.postForm.options = []
      if (v === 3) {
        this.postForm.options.push({ isRight: true, content: '正确', image: null, fileList: [] })
        this.postForm.options.push({ isRight: false, content: '错误', image: null, fileList: [] })
      }
      if (v === 1 || v === 2) {
        this.postForm.options.push({ isRight: false, content: '', image: null, fileList: [] })
        this.postForm.options.push({ isRight: false, content: '', image: null, fileList: [] })
        this.postForm.options.push({ isRight: false, content: '', image: null, fileList: [] })
        this.postForm.options.push({ isRight: false, content: '', image: null, fileList: [] })
      }
      if (v === 4) {
        this.postForm.options.push({ isRight: true, content: '', image: null, fileList: [] })
      }
    },

    // 添加子项
    handleAdd() {
      this.postForm.options.push({ isRight: false, content: '', image: null, fileList: [] })
    },

    removeItem(index) {
      this.postForm.options.splice(index, 1)
    },

    fetchData(id) {
      fetchDetail(id).then((response) => {
        this.postForm = response.data
      })
    },
    async submitForm() {
      let rightCount = 0

      // 安全处理options数组
      if (this.postForm.options && Array.isArray(this.postForm.options)) {
        this.postForm.options.forEach(function (item) {
          if (item.isRight) {
            rightCount += 1
          }
        })
      }
      if (this.postForm.quType === 1) {
        if (rightCount !== 1) {
          this.$message({
            message: '单选题答案只能有一个',
            type: 'warning'
          })
          return
        }
      }
      if (this.postForm.quType === 2) {
        if (rightCount < 2) {
          this.$message({
            message: '多选题至少要有两个正确答案！',
            type: 'warning'
          })
          return
        }
      }
      if (this.postForm.quType === 3) {
        if (rightCount !== 1) {
          this.$message({
            message: '判断题只能有一个正确项！',
            type: 'warning'
          })
          return
        }
      }
      // 确保每个选项都有 image 字段
      if (this.postForm.options && Array.isArray(this.postForm.options)) {
        this.postForm.options.forEach(option => {
          if (typeof option.image === 'undefined') {
            option.image = null
          }
        })
      }

      // 打印 options 结构
      console.log('提交前 options:', this.postForm.options)
      this.$refs.postForm.validate(async (valid) => {
        if (!valid) {
          return
        }

        // 安全处理options数组
        if (this.postForm.options && Array.isArray(this.postForm.options)) {
          for (let i = 0; i < this.postForm.options.length; i++) {
            const option = this.postForm.options[i]
            if (option.isRight) {
              option.isRight = 1
            } else {
              option.isRight = 0
            }
          }
        }
        // 拼接图片完整URL
        if (this.postForm.image && !this.postForm.image.startsWith('http')) {
          this.postForm.image = this.getFullImageUrl(this.postForm.image)
        }

        // 添加录题人信息
        const userInfo = getTokenInfo()

        if (userInfo && userInfo.realName) {
          this.postForm.realName = userInfo.realName
        }

        if (this.quId) {
          quUpdate(this.quId, this.postForm).then(res => {
            if (res.code) {
              this.$notify({
                title: '成功',
                message: `${res.msg}`,
                type: 'success',
                duration: 2000
              })
              this.$router.push({ name: 'questions-management' })
            } else {
              this.$notify({
                title: '失败',
                message: `${res.msg}`,
                type: 'error',
                duration: 2000
              })
            }
          })
        } else {
          quAdd(this.postForm).then((response) => {
            this.postForm = response.data
            if (response.code) {
              this.$notify({
                title: '成功',
                message: '试题保存成功！',
                type: 'success',
                duration: 2000
              })
              this.$router.push({ name: 'questions-management' })
            } else {
              this.$notify({
                title: '失败',
                message: `${response.msg}`,
                type: 'error',
                duration: 2000
              })
            }
          })
        }
      })
    },
    onCancel() {
      this.$router.push({ name: 'questions-management' })
    },
    getFullImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return 'http://localhost:9000' + path
    },
    handleOptionUploadSuccess(response, index) {
      if (response.code === 1) {
        this.$message.success('上传成功')
        const url = response.data.startsWith('http') ? response.data : this.getFullImageUrl(response.data)
        this.$set(this.postForm.options[index], 'image', url)
        console.log('上传后options:', this.postForm.options)
      } else {
        this.$message.error(response.msg || '上传失败')
      }
    },
    handleUploadError(error) {
      this.$message.error(error.msg || '上传失败')
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片')
      }
      return isImage
    }
  }
}
</script>

<style scoped>
.el-button--primary.is-plain {
  color: #409eff;
  background: #ecf5ff;
  border-color: #b3d8ff;
  margin-bottom: 25px;
}
</style>
